<template>
	<div ref="head" class="container" aria-label="当前为个人中心页面，点击个人信息按钮，会弹出个人信息展示窗口，您可以在这个窗口中补全您的个人信息，这将有助于我们更好地为您提供服务。点击退出登录按钮，您的登录状态将被清除，需要重新登录。" tabindex="0">
		<div class="list">
			<div
				class="list-item" 
				tabindex="0"
				role="button"
				@click="checkUserInfo()"
				@keydown.enter="checkUserInfo()"
			>
				个人信息
		</div>
		</div>

		<button class="logout-button" @click="logout()">
			退出登录
		</button>

		<div v-if="showInfoModal" class="modal">
			<div class="modal-box">
				<button id="userinfo-area" class="back-button" @click="closeInfoModal()" aria-label="关闭个人信息展示窗口" tabindex="0">×</button>
				<button class="edit-button" @click="editUserInfo()">
					{{ editingUserInfo ? '取消' : '编辑' }}
				</button>

				<div class="form">
					<div class="form-group">
						<label>姓名：</label>
						<input ref="UserInfoEditingArea" type="text" v-model.trim="userInfo.name" :readonly="!editingUserInfo" />
					</div>
					<div class="form-group">
						<label>学校：</label>
						<input type="text" v-model.trim="userInfo.school" :readonly="!editingUserInfo" />
					</div>
					<div class="form-group">
						<label>年级：</label>
						<input type="text" v-model.trim="userInfo.grade" :readonly="!editingUserInfo" />
					</div>
					<div class="form-group">
						<label>本人手机号：</label>
						<input type="text" v-model.trim="userInfo.myPhone" :readonly="!editingUserInfo" />
					</div>
					<div class="form-group">
						<label>本人微信号：</label>
						<input type="text" v-model.trim="userInfo.myWechat" :readonly="!editingUserInfo" />
					</div>
					<div class="form-group">
						<label>家长手机号：</label>
						<input type="text" v-model.trim="userInfo.guardianPhone" :readonly="!editingUserInfo" />
					</div>
					<div class="form-group">
						<label>家长微信号：</label>
						<input type="text" v-model.trim="userInfo.guardianWechat" :readonly="!editingUserInfo" />
					</div>
				</div>
				<button v-if="editingUserInfo" class="save-button" @click="saveUserInfo()">保存</button>
			</div>
		</div>


		<!-- 通用提示框 -->
		<div v-if="showModal" class="modal"  >
			<div class="modal-box" style="z-index: 2; display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; width: 300px; height: 200px;">
				<p ref="modalContent" style="position: absolute; top: 40px;" tabindex="0">{{ modalMessage }}</p>
				<button
					class="message-modal-button"
					@click="closeModal"
					ref="modalButton"
				>知道了</button>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import {baseUrl, getUserInfoUrl, updateUserInfoUrl, logoutUrl} from '@/constants/urls.js';

export default {
	data() {
		return {
			baseUrl: baseUrl,
			getUserInfoUrl: getUserInfoUrl,
			updateUserInfoUrl: updateUserInfoUrl,
			logoutUrl: logoutUrl,
			showModal: false,
			modalMessage: '',
			showInfoModal: false,
			editingUserInfo: false,
			userInfo: {
				name: '',
				school: '',
				grade: '',
				myPhone: '',
				myWechat: '',
				guardianPhone: '',
				guardianWechat: '',
			},
		};
	},
	mounted() {
		this.getUserInfo();
	},
	methods: {
		showMessageModal(text){
			this.modalMessage=text;
			this.showModal=true;
		},
		closeModal(){
			this.showModal=false;
		},
		checkUserInfo() {
			this.showInfoModal=true;
			setTimeout(() => {
				const userinfoArea=document.querySelector("#userinfo-area");
				userinfoArea.focus();
			}, 100);
		},
		closeInfoModal() {
			this.editingUserInfo=false;
			this.getUserInfo();
			this.showInfoModal=false;
		},
		editUserInfo() {
			if (!this.editingUserInfo) {
				this.editingUserInfo=true;
				this.$refs.UserInfoEditingArea.focus();
			} else {
				this.editingUserInfo=false;
			}
		},
		getUserInfo() {
			axios.get(`${this.baseUrl}${this.getUserInfoUrl}`).then(response => {
				this.userInfo.name=response.data.name;
				this.userInfo.school=response.data.school;
				this.userInfo.grade=response.data.grade;
				this.userInfo.myPhone=response.data.myPhone;
				this.userInfo.myWechat=response.data.myWechat;
				this.userInfo.guardianPhone=response.data.guardianPhone;
				this.userInfo.guardianWechat=response.data.guardianWechat;
			});
		},
		saveUserInfo() {
			axios.post(`${this.baseUrl}${this.updateUserInfoUrl}`, this.userInfo).then(response => {
				if (response.status == 200){
					this.closeInfoModal();
					this.showMessageModal("保存成功！");
				} else {
					this.showMessageModal("保存失败");
				}
			}).catch(error =>{
				this.showMessageModal("发生了错误"+error);
			});
		},
		logout() {
			axios.get(`${this.baseUrl}${this.logoutUrl}`).then(response => {
				if (response.status == 200){
					this.$router.push({"name": 'Login'});
				} else {
					this.showMessageModal('操作失败');
				}
			}).catch(error => this.showMessageModal('发生了错误'+error));
		}
	}
};
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	width: 50%;
	margin: auto;
}

.list {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 15px;
	margin-top: 10vh;
	margin-left: auto;
}

.list-item {
	background-color: #f0f0f0;
	padding: 15px;
	cursor: pointer;
	border-radius: 8px;
	font-size: 18px;
}

.list-item:hover {
	background-color: #dcdcdc;
}

.logout-button {
	width: 50%;
	align-self: center;
	margin-top: 40px;
	padding: 10px 20px;
	font-size: 18px;
	color: white;
	background-color: red;
	border: none;
	border-radius: 5px;
	cursor: pointer;
}

.logout-button:hover {
	background-color: darkred;
}

.modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
}

.modal-box {
	background: white;
	border-radius: 10px;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
	width: 500px;
	height: 500px;
	position: relative;
}

.back-button {
	position: absolute;
	top: 20px;
	left: 20px;
	width: 30px;
	height: 30px;
	border:none;
	font-size: 30px;
}

.edit-button {
	position: absolute;
	top: 20px;
	right: 20px;
	width: 70px;
	height: 30px;
	font-size: 10px;
	border: none;
	border-radius: 4px;
	color: white;
	background-color: rgb(0,  0, 200);
}

.form {
	position: absolute;
	top: 15%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.form-group {
	display: flex;
	align-items: flex-start;
	margin-bottom: 15px;
	width: 80%;
}

label {
	width: 40%;
	text-align: right;
	margin-right: 10%;
	font-size: 16px;
}

input {
	width: 50%;
	padding: 8px;
	border: 1px solid #ccc;
	border-radius: 5px;
}

.save-button {
	position: absolute;
	bottom: 5%;
	left: 50%;
	transform: translateX(-50%);
	border: none;
	border-radius: 4px;
	color: white;
	background-color: rgb(0,0,200);
	width: 80px;
	height: 40px;
	font-size: 20px;
}

.message-modal-button {
	position: absolute;
	top: 120px;
	width: 60px;
	height: 40px;
	background-color: rgb(0,0,200);
	border:none;
	border-radius: 4px;
	color: white;
	font-size: 90%;
}

@media (max-width: 500px){
	.container {
		width: 100%;
	}

	.list {
		margin-top: 15vh;
	}
	.modal-box {
		width: 90%;
		height: 400px;
	}

	.form {
		top: 60px;
	}

	.form-group {
		margin-bottom: 5px;
		width: 100%;
	}

	.save-button {
		bottom: 20px;
	}
}
</style>
